import { useTranslation } from 'react-i18next';

import ContextualHelp from '@/components/atoms/ContextualHelp/ContextualHelp';

/** First-visit intro banner; dismissal is persisted by ContextualHelp (D6). */
export const ImprovementsIntro = () => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      <ContextualHelp name="improvements_intro" title={t('improvements.intro_title')}>
        {t('improvements.intro_description')}
      </ContextualHelp>
    </div>
  );
};
